import{SIZE_LARGE_THRESHOLD as r,SIZES as t,SIZE_MEDIUM_THRESHOLD as n}from"./constants.js";var o=function(o){return o>=r?t.LARGE:o>=n?t.MEDIUM:t.SMALL};export{o as getSize};
